import React, { useRef } from 'react'
import * as Style from "./Styles";
import { icons, imgs } from "../../../constants/images";
import moment from 'moment';

export default function PopupViewQrcode(props: any) {
  const cardRef = useRef<HTMLElement>(null);
  const prepareURL = async () => {
    const cardElement = cardRef.current;
    if (!cardElement) return;
    try {
      const html2canvas = await import(
        "html2canvas"
      );

      const result = await html2canvas.default(cardElement);

      const asURL = result.toDataURL("image/jpeg");

      const anchor = document.createElement("a");
      anchor.href = asURL;
      anchor.download = `Qrcode_${props.detail?.stall?.stallNumber ? props.detail?.stall?.stallNumber.replace("/", '-') : ''}_${props.detail?.stall?.stallNumber ? moment().format('D-MM-YYYY') : moment().format('D-MM-YYYY_hh-mm-ss')}.jpeg`;
      anchor.click();
      anchor.remove();
    } catch (reason) {
      console.log(reason);
    }
  };
  return (
    <>
      <Style.BoxUploadImgContainer>
            <Style.ContainerQR>
              <Style.ThaiQR ref={cardRef}>
                <img src={imgs.thai_qr} />
                <Style.ImageQR src={props.qrCode} alt="" />
                <Style.TextQR className="w-100 d-flex justify-content-center mb-2">องค์การตลาดเพื่อเกษตรกร</Style.TextQR>
                {/* <Style.TextQR className="w-100 d-flex justify-content-center mb-2">099400016552800</Style.TextQR> */}
              </Style.ThaiQR>
              {/* <Style.ButtonDowload href={dowloadRef.current} download={dowloadRef.current} >ดาวน์โหลด</Style.ButtonDowload> */}
              <Style.ButtonDowload onClick={prepareURL}>ดาวน์โหลดQr code</Style.ButtonDowload>
            </Style.ContainerQR>
        
      </Style.BoxUploadImgContainer>

      {/* <Style.ButtonSubmit onClick={props.onsubmit}>บันทึก</Style.ButtonSubmit> */}
    </>
  )
}
